import { createPopper } from '@popperjs/core'

export default function openNavigationTooltip(target, tooltip, position = 'bottom') {
  const elTarget = $( target ).get(0);
  const elTooltip = $( tooltip ).get(0);

  createPopper(elTarget, elTooltip, {
    placement: position,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 50],
        },
      },
    ],
  });

  $( tooltip ).find('button.close').on('click', function(e) {
    e.preventDefault();

    $( tooltip ).remove();

    return false;
  });
};
